export const FieldObject: any = {}

export const addField = (target: string, component: any) => {
  if (target) {
    FieldObject[target] = component
  }
}
